import { T, Var, useGT } from 'gt-react';
import type { ArTaskRow } from '@erp/rpc';
import {
  isArTaskLate,
  formatArTaskAmount,
  issueLabel,
  referenceLabel,
} from './arTasksColumns';

/**
 * Compact row for the list-detail split's left rail: reference and amount,
 * customer and days, then why the task is open (e.g. "Portal customer, no
 * portal note").
 */
export function ArTasksRailRow({
  item,
  selected,
  onSelect,
}: {
  item: ArTaskRow;
  selected: boolean;
  onSelect: () => void;
}) {
  const gt = useGT();
  const late = isArTaskLate(item.daysPending);
  return (
    <button
      type="button"
      onClick={onSelect}
      className={`flex w-full cursor-pointer flex-col gap-0.5 rounded-md px-2 py-2 text-left ${
        selected ? 'bg-muted' : 'hover:bg-muted/50'
      }`}
    >
      <span className="flex justify-between gap-2 text-[13px]">
        <span className="truncate font-medium">{referenceLabel(item)}</span>
        <span className="tabular-nums">{formatArTaskAmount(item.amount)}</span>
      </span>
      <span className="flex justify-between gap-2 text-[11px] text-muted-foreground">
        <span className="truncate">{item.customerName ?? '—'}</span>
        {item.daysPending != null && (
          <span className={late ? 'text-red-700' : ''}>
            <T context="AR tasks rail, days pending, abbreviated">
              <Var>{item.daysPending}</Var>d
            </T>
          </span>
        )}
      </span>
      {/* An amber dot marks the exception without a badge's border and fill. */}
      <span className="flex min-w-0 items-center gap-1.5 text-[11px] text-amber-700">
        <span
          aria-hidden
          className="size-1.5 shrink-0 rounded-full bg-amber-500"
        />
        <span className="truncate">{issueLabel(item, gt)}</span>
      </span>
    </button>
  );
}
